import { environment } from '../../environments/environment';
import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ClearanceItemComponent, ClearanceListComponent } from './index';
import { pendingChangesGuard, roleGuard } from '../shared/core/index';
import { ClearanceItemHistoryComponent } from './clearance-item-history.component';
import { CarouselComponent } from './carousel.component';

export const CIRoutes: Routes = [
  {
    path: 'projects/:projectId/items',
    component: ClearanceListComponent,
    canActivate: [roleGuard], data: {
      roles: [environment.clearanceRole, environment.productionRole],
      key: 'itemlist'
    },
  },
  {
    path: 'projects/:projectId/items/:ciId',
    component: ClearanceItemComponent,
    canActivate: [roleGuard], data: {
      roles: [environment.clearanceRole, environment.productionRole],
      key: 'noflush'
    },
    canDeactivate: [pendingChangesGuard]
  },
  {
    path: 'projects/:projectId/items/:ciId/:assetType/:imageIndex',
    component: ClearanceItemComponent,
    canActivate: [roleGuard], data: {
      roles: [environment.clearanceRole, environment.productionRole],
      key: 'noflush'
    },
    canDeactivate: [pendingChangesGuard]
  },
  {
    path: 'projects/:projectId/items/:ciId/history',
    component: ClearanceItemHistoryComponent,
    canActivate: [roleGuard], data: {
      roles: [environment.clearanceRole, environment.productionRole],
      key: 'noflush'
    },
  },
  
];

export const ClearanceItemRouting: ModuleWithProviders<RouterModule> =
  RouterModule.forChild(CIRoutes);